import React from 'react'
import classes from './styles.module.scss'
import Header from './components/header.component';
import Sidebar from './components/sidebar.component';
import { Outlet } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import CurrentCall from './components/call.component';
import { useTheme } from '../../contexts/theme.context';
const baseClass = 'layout'

export const cn = (
  el?: string,
  mods: Record<string, boolean> = {},
  extra: string[] = []
) => {
  const element = el ? `${baseClass}__${el}` : baseClass

  const modClasses = Object.entries(mods)
    .filter(([_, value]) => value)
    .map(([key]) => `${baseClass}__${key}`)   // приклеиваем baseClass

  const extraClasses = extra.map(e =>
    classes[`${baseClass}__${e}`] || `${baseClass}__${e}`
  )

  return [
    classes[element],
    ...modClasses.map(m => classes[m] || m),
    ...extraClasses,
  ]
    .filter(Boolean)
    .join(' ')
}

const Layout = () => {
  const { theme } = useTheme();

  return (
    <div className={cn('')}>
      <Sidebar />
      <div className={cn('content')}>
        <Header />

        <div className={cn('content-body')}>
          <CurrentCall />
          <Outlet />
        </div>

        <ToastContainer
          theme={theme}
          transition={Slide}
          position="bottom-right"
          autoClose={3000}
          hideProgressBar
          closeOnClick
        />
      </div>
    </div>
  )
}

export default Layout